import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import NavigationButtons from '../../components/NavigationButtons';

import { FadeIn, NumberInput, Label, RadioInput } from 'hosman-material';

import { updateEstimationData } from '../../../../../../reducers/_Pages/Public/rentalFunnelSlice';

const PriceExpectations = () => {
  const { estimationData, estimationData: { priceExpectations, furnished, vacant }, errors } = useSelector((state) => state.rentalFunnel);
  const dispatch = useDispatch();

  return (
    <div data-testid='PriceExpectations'>
      <FadeIn>
        <div className='flex flex-col gap-6'>
          <p className='h2 text-ih-indigo'>Quel serait le loyer mensuel (charges comprises) idéal pour votre bien ?</p>

          <div className='relative'>
            <NumberInput
              name='price_expectations'
              placeholder='0'
              onChange={(e) => dispatch(updateEstimationData({
                ...estimationData,
                priceExpectations: e.target.value
              }))}
              value={priceExpectations}
              sign='€'
              autoFocus
            />

            <div className='absolute right-6 -top-3'>
              <Label color='bg-ih-purple'>Facultatif</Label>
            </div>
          </div>

          <RadioInput
            name='furnished'
            label='Le bien est-il meublé ou non meublé ?'
            options={[
              { name: 'Meublé', value: true },
              { name: 'Non meublé', value: false }
            ]}
            value={furnished}
            onChange={(val) => dispatch(updateEstimationData({ ...estimationData, furnished: val }))}
            errors={errors}
          />

          <RadioInput
            name='vacant'
            label='Le bien est-il actuellement loué ou vacant ?'
            options={[
              { name: 'Vacant', value: true },
              { name: 'Loué actuellement', value: false }
            ]}
            value={vacant}
            onChange={(val) => dispatch(updateEstimationData({ ...estimationData, vacant: val }))}
            errors={errors}
          />

          <NavigationButtons classes='hidden md:block my-5' />
        </div>
      </FadeIn>
    </div>
  )
}

export default PriceExpectations;
